export default "__VITE_ASSET__BVDFT68Z__"